import React from 'react';
import { FadeIn, Section, Button } from './ui';
import { Check, Shield, Download } from 'lucide-react';
export function HeroSection() {
  return <div className="relative pt-10" data-id="element-147">
      {/* Urgency Bar */}
      <div className="fixed top-0 left-0 right-0 bg-brand-orange text-white text-center py-2.5 px-4 z-50 font-bold text-xs md:text-base shadow-md" data-id="element-148">
        ⚡PROFESOR DE MATEMÁTICA DEJÁ DE PERDER TIEMPO
      </div>

      <Section variant="dark" className="!pt-2 md:!pt-16 !pb-6 md:!pb-10" data-id="element-149">
        <FadeIn data-id="element-150">
          <h1 className="text-[22px] md:text-5xl font-black text-white leading-[1.15] text-center mb-3 md:mb-5" data-id="element-151">
            ¿Llegás al domingo a la noche sin saber cómo vas a dar la clase del
            lunes?
          </h1>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-152">
          <p className="text-sm md:text-xl text-gray-300 text-center mb-4 md:mb-8 max-w-[600px] mx-auto leading-relaxed" data-id="element-153">
            Este sistema te da los scripts, las guías y los exámenes listos para
            usar.{' '}
            <span className="text-white font-semibold" data-id="element-154">
              Sin preparación extra. Sin improvisación. Sin estrés.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-155">
          {/* Product Image */}
          <div className="relative w-full max-w-[180px] md:max-w-[420px] mx-auto mb-4 md:mb-8" data-id="element-156">
            <img src="https://cdn.magicpatterns.com/uploads/mAckYZXMs86ELLFmRv3W6f/Emprendedor_Te_damos_una_solucion._(1080_x_1080_px)_(Post_de_Instagram_(45)).png" alt="Mega Kit Matemática 360 — Incluye ebook principal, 3 bonus exclusivos y materiales para un año" className="w-full h-auto drop-shadow-[0_20px_40px_rgba(255,107,0,0.15)]" loading="eager" decoding="async" data-id="element-157" />
          </div>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-158">
          <Button href="#pricing" variant="primary" className="text-base md:text-xl mb-3 md:mb-5" data-id="element-159">
            <span data-id="element-160">QUIERO EL SISTEMA AHORA →</span>
          </Button>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs md:text-sm text-gray-400" data-id="element-161">
            <div className="flex items-center gap-1" data-id="element-162">
              <Check size={14} className="text-green-500 shrink-0" data-id="element-163" />
              <span data-id="element-164">+847 docentes</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-165">
              <Download size={14} className="text-brand-blue shrink-0" data-id="element-166" />
              <span data-id="element-167">PDF al instante</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-168">
              <Shield size={14} className="text-brand-gold shrink-0" data-id="element-169" />
              <span data-id="element-170">Garantía 7 días</span>
            </div>
          </div>
        </FadeIn>
      </Section>
    </div>;
}